// extracted by mini-css-extract-plugin
export default {"details_container":"newShipmentDetails_details_container__FLFSd"};